import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileText, Trash2 } from "lucide-react";

export default function Documents() {
  const [docs, setDocs] = useState([]);

  const load = () => api.get("/documents").then((r) => setDocs(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post("/documents/upload", fd);
      toast.success("Uploaded");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally { e.target.value = ""; }
  };

  const remove = async (id) => {
    await api.delete(`/documents/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="min-h-screen" data-testid="documents-page">
      <header className="border-b border-zinc-200 page-px py-6 sm:py-8 flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="label-uppercase mb-2">Vault</div>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tighter" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Documents</h1>
        </div>
        <label className="bg-ikb text-white px-4 py-2.5 text-sm font-medium flex items-center gap-2 cursor-pointer hover:bg-[#00227A]" data-testid="upload-doc-button">
          <Upload size={14} /> Upload
          <input type="file" onChange={upload} className="hidden" />
        </label>
      </header>

      <div className="page-px py-6 sm:py-8">
        {docs.length === 0 ? (
          <div className="border border-dashed border-zinc-300 p-16 text-center">
            <FileText size={32} className="mx-auto text-zinc-400 mb-2" />
            <div className="text-sm text-zinc-500">No documents yet. Upload tax returns, contracts, KYC files…</div>
          </div>
        ) : (
          <div className="border border-zinc-200">
            <div className="grid grid-cols-12 label-uppercase border-b border-zinc-200 px-4 py-2 bg-zinc-50">
              <div className="col-span-5">File</div>
              <div className="col-span-2">Size</div>
              <div className="col-span-3">Uploaded By</div>
              <div className="col-span-2 text-right">Action</div>
            </div>
            {docs.map((d) => (
              <div key={d.id} className="grid grid-cols-12 px-4 py-3 border-b border-zinc-200 text-sm hover:bg-zinc-50 items-center">
                <a href={`${process.env.REACT_APP_BACKEND_URL}${d.url}`} target="_blank" rel="noreferrer" className="col-span-5 flex items-center gap-2 hover:text-[#002FA7] truncate">
                  <FileText size={14} className="text-zinc-400" /> {d.filename}
                </a>
                <div className="col-span-2 font-mono text-xs">{(d.size / 1024).toFixed(1)} KB</div>
                <div className="col-span-3 text-zinc-600">{d.uploaded_by_name}</div>
                <div className="col-span-2 text-right">
                  <button onClick={() => remove(d.id)} className="text-zinc-400 hover:text-red-600" data-testid={`delete-doc-${d.id}`}>
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
